import {dateToReadableDate} from '@date-picker';
import {Button, Divider} from '@ds/components';
import {PageLayout} from '@ds/layout';
import paymentSuccess from 'assets/images/pin-payment-success.svg';
import {useLocation, useNavigate} from 'react-router-dom';

import ProInfoRow from '../components/common/ProInfoRow/ProInfoRow';
import ProStatus from '../components/common/ProStatus/ProStatus';
import {PRO_ROUTES} from '../constants';

type ProPaymentSuccessState = {
  state?: string;
  start_time?: string;
  start_date?: string;
};

const ProPaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const data = (state ?? {}) as ProPaymentSuccessState;
  const startDate = data.start_time ?? data.start_date;

  return (
    <PageLayout
      footerPosition="static"
      footer={
        <Button
          fullWidth
          variant="fill"
          color="secondary"
          onClick={() => navigate(PRO_ROUTES.list)}
        >
          متوجه شدم
        </Button>
      }
    >
      <header className="px-4 py-6 text-center">
        <img className="mx-auto" src={paymentSuccess} alt="" aria-hidden />
        <h1 className="mt-4 text-subtitle-md text-neutral-fg">کمپین با موفقیت ایجاد شد.</h1>
        <p className="mt-1 text-body-sm text-gray-34">
          مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.
        </p>
      </header>
      <Divider className="bg-gray-02" size={8} />
      <section className="px-4">
        <ProInfoRow title="وضعیت" value={<ProStatus value={data.state} />} />
        <ProInfoRow
          title="تاریخ شروع"
          value={
            startDate
              ? dateToReadableDate({
                  date: startDate,
                  day: true,
                  month: true,
                  year: true
                })
              : ''
          }
          hasBorder={false}
        />
      </section>
    </PageLayout>
  );
};

export default ProPaymentSuccess;
